import moment from 'moment';

export const isSameDates = (startDate, endDate) => {
  const processedDate1 = moment(startDate).format('DD-MM-YY');
  const processedDate2 = moment(endDate).format('DD-MM-YY');
  return processedDate1 === processedDate2;
};
